
import { buildScriptTag } from "../script-utils";
import { ScriptProps } from "../script-types";

/**
 * Generates a standard tracking script with proper formatting
 * Uses URL parameters instead of data attributes for simplicity
 */
export function getStandardTrackingScript({ pixelId, scriptMetadata }: ScriptProps): string {
  const scriptTag = buildScriptTag({
    pixelId,
    scriptMetadata,
  });
  
  return scriptTag;
}
